import { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useAppContext } from "../context/AppContext";
import { apiFetch } from "../api";
import LoadingSpinner from "../components/LoadingSpinner";

import ProjectHero     from "../components/project-details/ProjectHero";
import ProjectNav      from "../components/project-details/ProjectNav";
import ProjectOverview from "../components/project-details/ProjectOverview";
import ProjectAmenities from "../components/project-details/ProjectAmenities";
import MasterPlan      from "../components/project-details/MasterPlan";
import UnitTypes       from "../components/project-details/UnitTypes";
import ProjectLocation from "../components/project-details/ProjectLocation";
import ContactCTA      from "../components/project-details/ContactCTA";

export default function Detail() {
  const { id }       = useParams();
  const { state }    = useLocation();
  const navigate     = useNavigate();
  const { lang }     = useAppContext();

  const [p, setP]         = useState(state?.property || null);
  const [loading, setLoading] = useState(!state?.property);

  useEffect(() => {
    if (!state?.property && id) {
      apiFetch("/api/properties/" + id)
        .then((data) => { setP(data); setLoading(false); })
        .catch(() => navigate("/properties"));
    }
  }, [id]);

  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          paddingTop: 80,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "var(--cream)",
        }}
      >
        <LoadingSpinner size={40} trackColor="rgba(201,168,76,.2)" />
      </div>
    );
  }

  if (!p) return null;

  return (
    <div style={{ background: "var(--cream)", minHeight: "100vh", paddingTop: 80 }}>
      {/* Full-width hero */}
      <ProjectHero p={p} />

      {/* Sticky anchor nav — starts invisible, fades in after scroll */}
      <ProjectNav lang={lang} />

      {/* Two-column content grid: main sections + sticky CTA sidebar */}
      <div className="pd-page-grid">
        <main>
          <ProjectOverview  p={p} />
          <ProjectAmenities p={p} />
          <MasterPlan       p={p} />
          <UnitTypes        p={p} />
          <ProjectLocation  p={p} />
        </main>

        <aside>
          <ContactCTA p={p} />
        </aside>
      </div>
    </div>
  );
}
